export default "__VITE_ASSET__BEl$sinQ__"